{
  "CSAT": {
    "TITLE": "Vurder samtalen din",
    "PLACEHOLDER": "Fortell oss mer...",
    "RATINGS": {
      "POOR": "😞 Dårlig",
      "FAIR": "😑 Grei",
      "AVERAGE": "😐 Gjennomsnittlig",
      "GOOD": "😀 Bra",
      "EXCELLENT": "😍 Utmerket"
    }
  }
}
